import React from "react";
import {
  PortalAuthActions,
  PortalAuthBranding,
  PortalAuthShell,
  PortalAuthSpinnerWrapper,
} from "@bto/shared";
import providerPortalLockup from "../assets/logos/provider-portal/unity-vert-cobranded.svg";
import vector from "../assets/icons/vector.svg";

interface ProviderAuthShellProps {
  children: React.ReactNode;
  description?: string;
  isError?: boolean;
  title?: string;
}

export const ProviderAuthShell = ({
  children,
  description,
  isError = false,
  title,
}: ProviderAuthShellProps): React.ReactElement => (
  <PortalAuthShell
    branding={
      <PortalAuthBranding
        accentSrc={vector}
        logoAlt="Unity by BillionToOne"
        logoSrc={providerPortalLockup}
      />
    }
    description={description}
    isError={isError}
    title={title}
  >
    {children}
  </PortalAuthShell>
);

export { PortalAuthActions as ProviderAuthActions };
export { PortalAuthSpinnerWrapper as ProviderAuthSpinnerWrapper };
